module.exports = __webpack_public_path__ + "img/footerLogo.46acfcdd.svg";